import { OfferReturnStrategy } from '@occc-app/dataAccessLayer/chain/types';
import { OfferFragment } from '@occc/graphql';
import { isEarningMechanismEarningMechanismPointSpend } from '@occc-app/routes/Reward/components/RewardConfigureForm/utils/isEarningMechanismEarningMechanismPointSpend';

const offerReturnStrategyToReturnableToggleValueMap: Record<
  Exclude<OfferReturnStrategy, 'PER_OFFER'>,
  boolean
> = {
  ON: true,
  OFF: false,
};

export const getIsOfferReturnableValue = (
  offerReturnStrategy: OfferReturnStrategy,
  offer: OfferFragment,
  offerReturnDefaultStrategy: boolean,
): boolean => {
  if (offerReturnStrategy === 'PER_OFFER') {
    return isEarningMechanismEarningMechanismPointSpend(offer)
      ? offer.earningMechanism.offerIsReturnable
      : offerReturnDefaultStrategy;
  }

  return offerReturnStrategyToReturnableToggleValueMap[offerReturnStrategy];
};
